import { Box, Button, IconButton, Typography } from '@mui/material';
import { Node } from 'reactflow';
import StartSharpIcon from '@mui/icons-material/PlayCircleOutline';
import { constants } from '../../constants/env';

export const NoWorkflowFound: Node[] = [
  {
    id: 'input-node',
    type: 'input',
    data: {
      label: (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '30px',
              height: '30px',
              backgroundColor: 'lightpink',
              borderRadius: '8px',
            }}
          >
            <IconButton sx={{ color: 'white' }}>
              <StartSharpIcon />
            </IconButton>
          </Box>
          <Box sx={{ marginTop: '2px', fontSize: '16px', fontWeight: 'normal' }}>
            Start
          </Box>
        </Box>
      ),
    },
    position: { x: 485, y: 10 },
    style: {
      padding: '12px',
      backgroundColor: '#fff',
      marginBottom: '12px',
      cursor: 'move',
      border: '1px solid #ccc',
      borderRadius: '6px',
      fontSize: '16px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      borderLeft: '4px solid red',
    },
  },
  {
    id: 'center-node',
    type: 'default',
    data: {
      label: (
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" fontWeight={600}>
            To Get Started, Please
          </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 1,
                backgroundColor: '#3D85C6',
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 400,
                fontSize: '12px',
                ':hover': { backgroundColor: '#3D85C6' },
              }}
              component="a"
              href={constants.REACT_APP_GIGSOURCE_ADD_STAGE_LINK}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              Add a Stage
            </Button>
          <Typography
            sx={{ mt: 1, fontSize: '12px', color: '#3D85C6', cursor: 'pointer' }}
          >
            Once added, your workflow will appear here.
          </Typography>
        </Box>
      ),
    },
    position: { x: 465, y: 150 },
    style: {
      padding: '20px',
      backgroundColor: '#fff',
      border: '1px dashed #ccc',
      borderRadius: '12px',
      width: '200px',
      textAlign: 'center',
      boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
      pointerEvents: 'all',
    },
  },
  {
    id: 'output-node',
    type: 'output',
    data: {
      label: (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '30px',
              height: '30px',
              backgroundColor: 'lightpink',
              borderRadius: '8px',
            }}
          >
            <IconButton sx={{ color: 'white' }}>
              <StartSharpIcon />
            </IconButton>
          </Box>
          <Box sx={{ marginTop: '2px', fontSize: '16px', fontWeight: 'normal' }}>
            Ready to Deliver
          </Box>
        </Box>
      ),
    },
    position: { x: 485, y: 400 },
    style: {
      padding: '12px',
      backgroundColor: '#fff',
      marginBottom: '12px',
      cursor: 'move',
      border: '1px solid #ccc',
      borderRadius: '6px',
      fontSize: '16px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      borderLeft: '4px solid red',
    },
  },
];
